import { Box, Button, Grid, Stack, Typography } from '@mui/material'
import moment from 'moment'
import React, { useState } from 'react'
import AnDateTimePicker from '../../../../../../components/DateTime/DateTimePicker'
import AccessType from './AccessType'
import AccessLocation from './AccessLocation'
import AccessSize from './AccessSize'
import AccessSuccess from './AccessSuccess'
import AccessComplications from './AccessComplications'

const IVIO = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Box padding={1}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">IV/IO</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
            size='small'
          />
        </Grid>
        <AccessType moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <AccessLocation moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <AccessSize moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <AccessSuccess moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <AccessComplications moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <Grid item xs={12}>
          <Button
            onClick={() => submitModule('IV/IO', moduleValues)}
            variant="contained"
            color="success"
            fullWidth
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default IVIO
